import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { LeafSupplierDetailsReport } from './Pages';

export const LeafSupplierDetailsReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={LeafSupplierDetailsReport} />
    </Fragment>
)